<template>
  <v-form v-bind="this.$attrs">
    <div>
      <v-row no-gutters>
        <v-col cols="10">
          <v-row>
            <!-- Chọn kỳ kiểm tra -->
            <v-col cols="4">
              <v-select
                :items="exams"
                v-model="exam"
                label="Chọn kỳ kiểm tra"
                item-value="id"
                item-text="name"
                return-object
                outlined
                dense
                clearable
                hide-details
                @change="examSelected"
              ></v-select>
            </v-col>

            <!-- Chọn tổ hợp môn -->
            <v-col cols="4">
              <v-select
                :items="subjectGroups"
                v-model="subjectGroup"
                label="Chọn tổ hợp môn"
                item-value="id"
                item-text="name"
                return-object
                outlined
                dense
                clearable
                hide-details
                @change="subjectGroupSelected"
                :disabled="!exam"
              ></v-select>
            </v-col>

            <!-- Chọn môn kiểm tra (optional) -->
            <v-col cols="4">
              <v-select
                :items="filteredSubjects"
                v-model="subject"
                label="Chọn môn kiểm tra"
                item-value="id"
                item-text="name"
                return-object
                outlined
                dense
                clearable
                hide-details
                :disabled="!subjectGroup"
                class="pr-6"
              ></v-select>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="2">
          <v-btn
            :disabled="!exam || !subjectGroup"
            height="40"
            width="100%"
            style="background-color: white"
            color="#0D47A1"
            @click="onFilterChanged"
            outlined
          >
            Xác nhận
          </v-btn>
        </v-col>
      </v-row>

      <!-- Bộ lọc nâng cao (tùy chọn) -->
      <v-row no-gutters class="pt-6">
        <v-col cols="10">
          <v-row v-if="advancedFilter">
            <v-col cols="4">
              <v-text-field
                v-model="examCode"
                label="Mã đề thi"
                clearable
                outlined
                dense
                hide-details
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="2">
          <v-btn
            color="primary"
            height="40px"
            width="100%"
            @click="advancedFilter = !advancedFilter"
            text
          >
            Nâng cao
            <v-icon v-if="!advancedFilter">mdi-chevron-down</v-icon>
            <v-icon v-else>mdi-chevron-up</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </v-form>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      exam: null,
      subjectGroup: null,
      subject: null,
      examCode: '',
      exams: [],
      subjectGroups: [],
      filteredSubjects: [],
      advancedFilter: false
    }
  },
  async mounted() {
    await this.getExams()
  },
  methods: {
    ...mapActions('exam', ['fetchExams']),
    ...mapActions('subjectExamGroup', ['fetchSubjectGroups']),

    // Lọc dữ liệu
    onFilterChanged() {
      const params = {
        exam: this.exam && this.exam.id ? this.exam.id : '',
        subjectGroup: this.subjectGroup && this.subjectGroup.id ? this.subjectGroup.id : '',
        subject: this.subject && this.subject.id ? this.subject.id : '',
        examCode_contains: this.examCode
      }
      this.$emit(
        'onFilterChanged',
        params,
        this.exams,
        this.filteredSubjects,
        this.subjectGroups,
        this.examCode
      )
    },

    // Lấy danh sách kỳ kiểm tra
    async getExams() {
      this.$loading.active = true
      this.exams = await this.fetchExams({ status: 'active' })
      this.$loading.active = false
    },

    // Chọn kỳ kiểm tra → load tổ hợp môn
    async examSelected() {
      if (!this.exam) {
        this.subjectGroups = []
        this.subjectGroup = null
        this.subject = null
        this.filteredSubjects = []
        return
      }

      this.$loading.active = true
      this.subjectGroups = await this.fetchSubjectGroups({
        exam: this.exam.id,
        _sort: 'index:asc'
      })
      this.subjectGroup = null
      this.subject = null
      this.filteredSubjects = []
      this.$loading.active = false
    },

    // Chọn tổ hợp môn → lọc môn
    subjectGroupSelected() {
      this.filteredSubjects = this.subjectGroup && this.subjectGroup.subjects || []
      this.subject = null
    }
  }
}
</script>
